const find = (selector, el = document) => el.querySelector(selector);

export {find};
